<script setup lang="ts">
defineProps<{
  label: string
  forId: string
  error?: string
  helperText?: string
}>()
</script>

<template>
  <div>
    <label class="mb-1 block text-sm font-medium text-slate-700" :for="forId">{{ label }}</label>
    <slot />
    <p v-if="helperText && !error" class="mt-1 text-xs text-slate-500">{{ helperText }}</p>
    <p v-if="error" class="mt-1 text-sm text-rose-600">{{ error }}</p>
  </div>
</template>

